import type { ManlyProfile } from "../profile";
import { ProjectionChart } from "./ProjectionChart";

export function ProjectionPage({ profile, onNext }: { profile: ManlyProfile; onNext: () => void }) {
  return (
    <>
      <div className="qk-manly-kicker">Projected result</div>
      <h2>Where his odor is headed.</h2>
      <p>
        Based on his answers, here is how fast his odor comes under control once the bacteria stop
        surviving.
      </p>

      <div className="qk-manly-chartcard">
        <div className="qk-manly-chart-head">
          <div className="qk-manly-chart-cell">
            <div className="qk-manly-eyebrow">Status</div>
            <div className="qk-manly-val">{profile.verdict}</div>
          </div>
          <div className="qk-manly-chart-cell">
            <div className="qk-manly-eyebrow">Full control</div>
            <div className="qk-manly-val is-accent">72 HRS</div>
          </div>
          <div className="qk-manly-chart-cell">
            <div className="qk-manly-eyebrow">His reset</div>
            <div className="qk-manly-val">WEEK 2</div>
          </div>
        </div>
        <ProjectionChart verdict={profile.verdict} />
      </div>

      <button type="button" className="qk-cta" onClick={onNext}>See what fixes it</button>
    </>
  );
}
